import { getBuyerId, getUserType } from 'dibs-cookie-jar';
import { graphql, fetchQuery, Environment } from 'react-relay';
import idx from 'idx';
import {
    PRIORITIES,
    PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
} from '../pdpSharedNotificationConstants';
import { hasTooltipBeenDismissed, hasUserSeenTooltip } from './helpers';

import {
    pdpSharedNotificationTradeRequestAppointmentTooltipConfigQueryResponse as ResponseType,
    pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery as OperationType,
} from './__generated__/pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery.graphql';

const query = graphql`
    query pdpSharedNotificationTradeRequestAppointmentTooltipConfigQuery($userId: String = "") {
        viewer {
            disableRequestAppointment: isEnabled(key: "disablePdpRequestAppointment")
            anchorLists(listNames: ["REQUEST_APPOINTMENT_MVP"]) {
                members {
                    anchor {
                        sourceId
                    }
                }
            }
            user(userId: $userId) {
                tradeFirm {
                    serviceId
                }
            }
        }
    }
`;

const pdpTradeRequestAppointmentTooltipRule: (params: {
    relayEnvironment: Environment;
}) => Promise<boolean> = async ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);
    const isTradeUser = getUserType(document.cookie) === 'trade';
    if (!userId || !isTradeUser || hasTooltipBeenDismissed || hasUserSeenTooltip) {
        return false;
    }

    const response: ResponseType = await fetchQuery<OperationType>(relayEnvironment, query, {
        userId,
    });
    const isDisabled = idx(response, o => o.viewer.disableRequestAppointment);
    const tradeFirmId = idx(response, o => o.viewer.user.tradeFirm.serviceId) || '';
    const whitelist = idx(response, o => o.viewer.anchorLists[0].members) || [];
    const firmIsWhitelisted = !!whitelist.find(
        member => idx(member, o => o.anchor.sourceId) === tradeFirmId
    );

    return !isDisabled && firmIsWhitelisted;
};

export default {
    name: PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
    priority: PRIORITIES.PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
    rule: pdpTradeRequestAppointmentTooltipRule,
    //TODO: $TSFixMe is used because of an issue with importing the Dispatch type from react-redux
    //there are currently multiple versions of react-redux installed, this will need to be resolved
    action: () => (dispatch: $TSFixMe) =>
        dispatch({
            type: PDP_TRADE_REQUEST_APPOINTMENT_TOOLTIP,
        }),
};
